exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download-list[data-v-682f7c22]{display:flex;flex-direction:column;align-items:stretch}.download-list .download[data-v-682f7c22]{display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #f5f5f5;padding:23px 9px 23px 2px;color:#1b1c1f;font-size:.875rem;font-weight:500;letter-spacing:0;line-height:1.125rem;transition:color .2s}.download-list .download[data-v-682f7c22]:hover{color:#2b5182}.download-list .download .title[data-v-682f7c22]{display:flex;align-items:center}.download-list .download .title[data-v-682f7c22]  svg{margin-right:10px}.download-list[data-v-682f7c22]  svg path{fill:currentColor}", ""]);

// exports
